import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl(id) {
  return `v1/stock/auto-trading/${id}/pause/`;
}

/**
 * @param {string} url
 * @returns
 */
export function callbackPause(url) {
  return async () => {
    try {
      /**
       * @type {import('./type').AutoOrderSingleResponse} res
       */
      const res = await fetcher.put(url);

      return res.data.result;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function putV1StockAutoOrderPause(id) {
  const url = getUrl(id);
  const cb = callbackPause(url);
  const key = [url, id];

  return { cb, key };
}
